export { useViewerContext } from '@thesisedu/feature-users-web'
